import React from "react";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";

interface ComponentProps {
  value: { phone: string; code: string };
  onChange: (value: { phone: string; code: string }) => void;
  selectedCountry?: string;
  disabled?: boolean;
}

const CustomPhoneInput: React.FC<ComponentProps> = ({
  value,
  onChange,
  selectedCountry,
  disabled,
}) => {
  return (
    <PhoneInput
      country={selectedCountry?.toLowerCase() ?? "us"}
      value={value?.phone ?? null}
      disabled={disabled}
      onChange={(value, country: any) => {
        onChange({
          phone: value,
          code: country?.countryCode.toUpperCase(),
        });
      }}
      inputProps={{
        required: true,
      }}
      countryCodeEditable
      enableSearch
      inputClass="!outline-none !h-[33px] !ring-0 text-[12px] !border-none !bg-[transparent] !text-primary-dark !font-switzer !text-[12px] !m-0 !ml-[13%] !w-[87%] !pl-[5px]"
      containerClass="!bg-transparent !h-[35px] rounded-[4px] !w-full !border-muted !border-[0.5px]"
      buttonClass="!h-[33px] w-[13%] !bg-transparent [&>div]:!bg-transparent !border-0 !border-r-[0.5px] !border-muted !outline-none !text-primary-dark"
      searchPlaceholder="Search countries"
      searchNotFound="No country found"
      disableSearchIcon
      dropdownClass="dark:!bg-[#2A2C30] bg-background !text-left !font-switzer !text-[12px] !text-[#758599]"
      searchClass="!font-switzer !text-[12px]  !ring-0 bg-background dark:!bg-[#2A2C30] [&>input]:!bg-transparent [&>input]:!border-muted [&>input]:!border-[0.5px] [&>input]:!py-1"
    />
  );
};
export default CustomPhoneInput;
